import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from '@material-ui/core/AccordionSummary';

const AccordionSummary: React.FC<AccordionSummaryProps> = withStyles(
  (theme) => ({
    root: {
      paddingLeft: 0,
      paddingRight: 0,
      userSelect: 'auto',
    },
    focused: {
      backgroundColor: 'unset !important',
    },
    content: {
      display: 'block',
      margin: theme.spacing(2, 0),
    },
  }),
)(
  React.forwardRef((props, ref) => (
    <MuiAccordionSummary {...props} ref={ref} />
  )),
);

export default AccordionSummary;
